import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-118c5534"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "login-block" };
const _hoisted_2 = { class: "login" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "sign-in-message" }, "Sign in with MSAL connection", -1));
import { inject } from "vue";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import { useStore } from "@/shared/composables/useStore";
import { AllActionTypes } from "@/store/action-types";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Login',
    setup(__props) {
        const store = useStore();
        const authService = inject("authService");
        const onClick = () => {
            store.dispatch(AllActionTypes.LOGIN, authService);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(OneDeskButton, {
                        class: "login-button",
                        "with-radius": true,
                        onClick: onClick
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode("Sign In")
                        ]),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
